export default __webpack_public_path__ + "static/media/presentGirl2.e25120d0.jpg";